import React from 'react';
import './Textesbon.css';

const Textebon = ({ children }) => {
  return (

    <div className='boss-texte1'>
    <h2 className='enfant-text1'>  <div className='trait-court1'></div> BON A SAVOIR  <div className='traitt-long1'></div> </h2> 
    <div className='texte-bon-a-savoir'>
      <p>
    Le mariage civil est une démarche volontaire, fondée sur le consentement des époux(ses), quelle que soit leur nationalité, qui conférera à leur
     union un régime juridique défini par le Code Civil. Le mariage civil est le seul mariage légalement reconnu. Il doit nécessairement précéder toute cérémonie religieuse.
      Il est célébré par un élu municipal dans un contexte solennel et répond à des conditions de fond et de forme.
      </p>
    </div>
    </div>
   
  );
};

export default Textebon ;
